import React, { useMemo } from 'react';
import { logNetRequest } from '@utils/usefulFuncs';
import { useSearchParams } from 'react-router-dom';
import { handle400Statuses, sendApiRequest } from '@services/api';

export const usePreselectedTickers = () => {
  const [searchParams] = useSearchParams();

  const [state, setState] = React.useState({ tickers: [], complete: false });

  const validateTicker = async (symbol) => {
    const normalizedSymbol = symbol.toUpperCase();
    let URL = `v1/genai_tickers_search?query=${normalizedSymbol}`;
    const { status, data, error } = await sendApiRequest('get', URL);
    handle400Statuses(status);
    logNetRequest(status, data, { symbol: normalizedSymbol });
    if (status === 200) {
      let found = null;
      data.forEach((r) => {
        if (r.symbol === normalizedSymbol) {
          found = r;
        }
      });
      if (found !== null) {
        return normalizedSymbol;
      }
    }
    return null;
  };

  const validateTickers = async (tickerParam) => {
    const tickers = Array.isArray(tickerParam) ? tickerParam : [tickerParam];
    return Promise.all(tickers.map((ticker) => validateTicker(ticker)))
      .then((result) => {
        // console.log({ result });
        return result.filter((r) => !!r);
      })
      .catch((error) => []);
  };

  React.useEffect(() => {
    const checkForTickerParams = async () => {
      const param = searchParams.get('ticker') || searchParams.get('tickers');
      if (param) {
        const unvalidatedTickers = param.split(',');
        const validatedTickers = await validateTickers(unvalidatedTickers);
        setState({ tickers: validatedTickers, complete: true });
      } else {
        setState({ tickers: [], complete: true });
      }
    };
    checkForTickerParams();
  }, []);

  return useMemo(() => {
    return state;
  }, [state]);
};
